import { render, staticRenderFns } from "./drawer-special-detail.vue?vue&type=template&id=5e2786b0&scoped=true"
import script from "./drawer-special-detail.vue?vue&type=script&lang=js"
export * from "./drawer-special-detail.vue?vue&type=script&lang=js"
import style0 from "./drawer-special-detail.vue?vue&type=style&index=0&id=5e2786b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2786b0",
  null
  
)

export default component.exports